/**
 * @license Copyright © HatioLab Inc. All rights reserved.
 */

import '@operato/markdown'

import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'

import { ScrollbarStyles } from '@operato/styles'

export class ComponentDetail extends LitElement {
  static styles = [
    ScrollbarStyles,
    css`
      :host {
        display: flex;
        flex-direction: column;
        align-content: stretch;

        background-color: var(--component-detail-background-color, white);
        margin: 0px;
        padding: 10px;

        width: 360px;
        height: 100%;

        overflow: hidden;

        border: 2px solid var(--component-detail-border-color);
        box-sizing: border-box;

        position: absolute;
        top: 0px;

        z-index: 1;
      }

      ox-markdown {
        flex: 1;
      }
    `
  ]

  @property({ type: Object }) template: { about: string } | null = null

  render() {
    const { about } = this.template || {}

    return html` <ox-markdown .src=${about}></ox-markdown> `
  }
}
